<script setup>

import { ref, inject, watch, provide } from 'vue';
import { 
	apiModifierListeValeurs,
	apiSupprimerListesValeurs } from '@/services/ServiceModele.js';
import ModaleEditionValeursListe from './ModaleEditionValeursListe.vue';
import Tag from 'primevue/tag';

const { listeValeurs } = defineProps({
  listeValeurs: Object
});

const afficherBarreFlottante = inject('afficherBarreFlottante');
const appelerApiModifModele = inject('appelerApiModifModele');

const texteNom = ref(listeValeurs.nom);
const texteLibelle = ref(listeValeurs.libelle);
const affichageModaleEditionValeursListe = ref(false);
const boutonMenu = ref(null);

watch(() => listeValeurs, (liste) => {
	texteNom.value = liste?.nom;
	texteLibelle.value = liste?.libelle;
});

watch(() => listeValeurs?.nom, (nom) => {
	texteNom.value = nom;
});

watch(() => listeValeurs?.libelle, (libelle) => {
	texteLibelle.value = libelle;
});

const itemsMenu = [
	{
		libelle: 'Supprimer',
		icones: ['fa fa-trash'],
		style: 'color: var(--couleur-supprimer); ',
		commande: () => {
			supprimer();
		}
	}
];

function basculerAffichageMenu() {
    afficherBarreFlottante({
        items: itemsMenu, 
        selectionItems: [],
        composantParent: boutonMenu.value
    });
}

function reinitialiserValeurs() {
	texteNom.value = listeValeurs.nom;
	texteLibelle.value = listeValeurs.libelle;
}

function editerValeurs() {
	affichageModaleEditionValeursListe.value = true;
}

function modifierNom() {
	console.log("Renommage de la liste de valeurs " + listeValeurs.nom + " en " + texteNom.value);
	const listeValeursModifiee = dupliquerListeValeurs(listeValeurs);
	listeValeursModifiee.nom = texteNom.value;
	modifierListeValeurs(listeValeursModifiee);
}

function modifierLibelle() {
	console.log("Modif du libellé de la liste de valeurs " + listeValeurs.nom + " en " + texteLibelle.value);
	const listeValeursModifiee = dupliquerListeValeurs(listeValeurs);
	listeValeursModifiee.libelle = texteLibelle.value;
	modifierListeValeurs(listeValeursModifiee);
}

function dupliquerListeValeurs(listeValeurs) {
	return {
		id: listeValeurs.id, 
		nom: listeValeurs.nom, 
		libelle: listeValeurs.libelle,
		valeurs: listeValeurs.valeurs
	};
}

function modifierListeValeurs(listeValeurs) {
	appelerApiModifModele(apiModifierListeValeurs, listeValeurs);
}

function supprimer() {
	appelerApiModifModele(apiSupprimerListesValeurs, [listeValeurs]);
}

provide('affichageModaleEditionValeursListe', affichageModaleEditionValeursListe);
provide('dupliquerListeValeurs', dupliquerListeValeurs);

</script>

<template>
	<div class="liste-valeurs">
		<div class="detail-liste-valeurs">
			<label class="intitule">Nom :</label>
			<div class="zone-nom">
				<input type="text" class="saisie-nom" spellcheck="false" 
					v-model="texteNom" 
					@keyup.enter="modifierNom()"
					@blur="reinitialiserValeurs" />
				<button class="bouton fa-solid fa-caret-down" 
					ref="boutonMenu"
					@click.stop="basculerAffichageMenu" />
			</div>
			<label class="intitule">Libellé :</label>
			<input type="text" spellcheck="false" 
				v-model="texteLibelle" 
				@keyup.enter="modifierLibelle()"
				@blur="reinitialiserValeurs" />
			<label class="intitule">Valeurs :</label>
			<div class="liste-badges" tabindex="0" @click="editerValeurs()">
				<label v-if="listeValeurs.valeurs.length == 0" class="remarque">Aucune valeur</label>
				<Tag v-for="valeur in listeValeurs.valeurs" class="badge valeur-liste">
					{{ valeur.nom }}
				</Tag>
			</div>
		</div>
	</div>
	<ModaleEditionValeursListe :listeValeurs="listeValeurs" />
</template>

<style scoped>

.liste-valeurs {
	display: flex;
	flex-direction: column;
}
.detail-liste-valeurs {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	margin-top: 10px;
	padding-left: 5px;
	align-items: start;
}

.zone-nom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.saisie-nom {
	margin-right: 2px;
	flex-grow: 1;
	min-width: 20px;
}

.remarque {
	cursor: inherit;
}

.liste-badges {
	border: solid 1px var(--couleur-bordure);
	border-radius: 2px;
	padding: 2px;
	user-select: none;
	background-color: white;
}

.liste-badges:hover {
	border-color: var(--couleur-survol);
	cursor: pointer;
}

.badge {
	border: solid 1px var(--couleur-bordure);
	border-radius: 5px;
	user-select: none;
	padding: 5px 7px;
	font-weight:700 !important;
	font-size: 8px !important;
}

.valeur-liste {
	background-color: var(--couleur-valeur-liste) !important;
	margin: 0px 1px;
}

</style>